import { render, staticRenderFns } from "./ListarProfesiograma.vue?vue&type=template&id=4bff573c"
import script from "./ListarProfesiograma.vue?vue&type=script&lang=js"
export * from "./ListarProfesiograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports